import { createSelector } from 'reselect';

const selectGlobal = () => (state) => state.get('global');

const selectRedirectedFrom = () =>
  createSelector(selectGlobal(), (globalState) =>
    globalState.get('redirectedFrom')
  );

export { selectRedirectedFrom };
